import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

function callback () {
  const callback = document.querySelector('.js-callback')

  if (!callback) return;

  const btn = callback.querySelector('.js-callback-toggler')

  btn.addEventListener('click', e => {
    e.preventDefault()
    callback.classList.toggle('active')
  })

  document.addEventListener('click', e => {
    if (!e.target.closest('.js-callback')) {
      callback.classList.remove('active')
    }
  })

  ScrollTrigger.create({
    trigger: '.js-footer',
    start: 'top bottom',
    onEnter: () => {
      document.body.classList.add('hide-float-icons')
    },
    onEnterBack: () => {
      document.body.classList.add('hide-float-icons')
    },
    onLeave: () => {
      document.body.classList.remove('hide-float-icons')
    },
    onLeaveBack: () => {
      document.body.classList.remove('hide-float-icons')
    },
  })
}

export { callback }